import XLSX from 'xlsx'

function _file (file: File, callback: Function) {
  const make_cols = (refstr: string) => {
    Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
      name: XLSX.utils.encode_col(i),
      key: i
    }))
  }

  const reader = new FileReader()
  reader.onload = (e: Event) => {
    const bstr = (e.target as EventTarget & {
      result: any;
    }).result

    const wb = XLSX.read(bstr, {
      type: 'binary'
    })

    const wsname = wb.SheetNames[0]
    const ws = wb.Sheets[wsname]

    const data = XLSX.utils.sheet_to_json(ws, {
      header: 1
    })

    callback(data, make_cols(ws['!ref'] as string))
  }
  reader.readAsBinaryString(file)
}

export function importExcel (callback: Function) {
  const inputObj = document.createElement('input')
  inputObj.setAttribute('id', 'file')
  inputObj.setAttribute('type', 'file')
  inputObj.setAttribute('name', 'file')
  inputObj.setAttribute('style', 'visibility:hidden')
  inputObj.setAttribute('accept', '.xlsx,.xls')
  inputObj.addEventListener('change', (evt) => {
    const files = (evt.target as EventTarget & {
      files: File[];
    }).files

    if (files && files[0]) {
      _file(files[0], (data: any, dataRef: any) => {
        callback(data, dataRef)
      })
    }
  })
  document.body.appendChild(inputObj)
  inputObj.click()
}
